/* eslint-disable @nice-cxone/ccf/required-tsdoc */
import { useState, useEffect, useCallback } from 'react';
import { callApi, API_BASE_URL, ADMIN_ACCESS } from 'libs/react/ui-components/src/lib/ccf-app-space/ccf-copilot/ccf-copilot-api';
import { useMsal } from '@azure/msal-react';

export const useAdminAccess = () => {
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
  const [adminEmails, setAdminEmails] = useState<string[]>([]);
  const { accounts } = useMsal();

  const isAdminUser = useCallback(
    (adminAccessEmails: string[]): boolean => {
      const loggedInUsername = accounts[0]?.username?.toLowerCase();
      if (!loggedInUsername) return false;
  
      const adminUsernames = adminAccessEmails.map((email) => email.split('@')[0]);
      const [loggedInUsernamePart, loggedInDomain] = loggedInUsername.split('@');
  
      return (
        adminUsernames.includes(loggedInUsernamePart) &&
        loggedInDomain.includes('nice')
      );
    },
    [accounts] 
  );

  useEffect(() => {
    const fetchAdminAccess = async () => {
      try {
        const response = await callApi(API_BASE_URL + ADMIN_ACCESS, 'GET');
        const emails = Array.isArray(response) ? response.map((email: string) => email.toLowerCase()) : [];
        setAdminEmails(emails);
        setIsAuthorized(isAdminUser(emails));
      } catch (error: any) {
        console.error('Error fetching admin emails:', error.message);
      }
    };

    fetchAdminAccess();
  }, [accounts]);

  return { isAuthorized, adminEmails };
};